import { api } from "@/api";

export async function addFavoriteMatch(matchId: number) {
  const res = await api.client.post("/favorite-matches", { matchId });
  return res.data;
}
